import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useScope } from "../context/ScopeContext";

/**
 * `/premises/:id` is no longer a page - it is the act of scoping to a premise.
 * Sets the header's Location and hands off to that location's overview, so
 * every existing link, bookmark and row click still works.
 */
export default function PremiseRedirect() {
  const { premiseId = "" } = useParams<{ premiseId: string }>();
  const { scope, setScope } = useScope();

  useEffect(() => {
    if (premiseId && scope.premiseId !== premiseId) {
      setScope({ premiseId });
    }
  }, [premiseId, scope.premiseId, setScope]);

  return <Navigate to="/places/overview" replace />;
}
